class billChangeService {
    constructor(logger, globalFn, sweetalert, httpRequest, $http) {
        this.lengthForString = function (temp) {
            let len = 0
            temp = $.trim(temp)
            for (let i = 0; i < temp.length; i++) {
                const c = temp.charCodeAt(i)
                // 单字节加1
                if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) { len++ } else { len += 2 }
            }
            return len
        }
        // 匹配是否正确单价
        this.isPrice = function (v) {
            const reg_num = /^\d{1,12}(\.\d{0,15})?$/ // 金额规则 数字，小数点前12位，后15位
            return globalFn.isPositiveFloatNum(v) && parseFloat(v) !== 0 && reg_num.test(v)
        }
        // 是否正确数字
        this.isQuantity = function (v) {
            const reg_num = /^\d{1,12}(\.\d{0,15})?$/ // 金额规则 数字，小数点前12位，后15位
            return globalFn.isPositiveFloatNum(v) && parseFloat(v) !== 0 && reg_num.test(v)
        }
        // 是否正确的金额
        this.isAmount = function (v) {
            const reg_je = /^\d{1,12}(\.\d{0,2})?$/ // 金额规则 数字，小数点前12位，后2位
            return globalFn.isPositiveFloatNum(v) && parseFloat(v) !== 0 && reg_je.test(v)
        }

        // 精确n位小数
        this._toFixed = function (v, n) {
            return parseFloat(v).toFixed(n)
        }
        // 是否含税
        this.isTax = function (obj) {
            return obj.isTax === '1'
        }

        // 是否差额
        this.hasBalanced = function (detail) {
            return (detail.length == 1 || detail.length == 2) && detail[0].balance != 0 && detail[0].balance != null
        }

        /**
         * 计算税额
         * @modaldata amt--金额
         * @modaldata taxrate--税率
         * @modaldata taxFlag--含税标志
         */
        this.taxCalculation = function (amt, taxrate, taxFlag) {
            let taxamount = 0
            if (taxFlag == '1') { // 含税
                taxamount = parseFloat(amt * taxrate / (1 + parseFloat(taxrate))).toFixed(2)
                if (taxrate == '0.015') {
                    taxamount = parseFloat(amt / 1.05 * 0.015).toFixed(2)
                }
            } else { // 不含税
                taxamount = parseFloat(amt * taxrate).toFixed(2)
                if (taxrate == '0.015') {
                    taxamount = parseFloat(amt * 1.015 / 1.05 * 0.015).toFixed(2)
                }
            }
            return taxamount
        }

        // 是否含有折扣行
        this.hasDisBalelectedArr = function (arr, oldid) {
            const selectedArr = []
            const o = arr
            let fl = false
            for (const m in o) {
                if (o[m].hasOwnProperty(oldid) && o[m][oldid] && (o[m].discountRate || o[m].balance)) {
                    fl = true
                    break
                }
            }
            return fl
        }
        // 税率数组
        this.getTaxRateArr = function (invoiceType) {
            /** 税率数组
             *    {taxText: '文本',
            *    taxRate: 0}
             * */
            let taxRateArr = [
                {
                    taxText: '3%',
                    taxRate: 0.03,
                }, {
                    taxText: '4%',
                    taxRate: 0.04,
                }, {
                    taxText: '5%',
                    taxRate: 0.05,
                }, {
                    taxText: '6%',
                    taxRate: 0.06,
                }, {
                    taxText: '9%',
                    taxRate: 0.09,
                }, {
                    taxText: '10%',
                    taxRate: 0.10,
                }, {
                    taxText: '11%',
                    taxRate: 0.11,
                }, {
                    taxText: '13%',
                    taxRate: 0.13,
                }, {
                    taxText: '16%',
                    taxRate: 0.16,
                }, {
                    taxText: '17%',
                    taxRate: 0.17,
                }]
            if (invoiceType === '0') {
                taxRateArr.unshift({
                    taxText: '减按1.5%计征',
                    taxRate: 0.015,
                })
            } else if (invoiceType === '51') {
                taxRateArr.unshift({
                    taxText: '0%',
                    taxRate: 0,
                })
            } else if (invoiceType === '14') {
                taxRateArr = [{
                    taxText: '3%',
                    taxRate: 0.03,
                }]
            } else if (invoiceType === '12') {
                taxRateArr = [{
                    taxText: '3%',
                    taxRate: 0.03,
                }, {
                    taxText: '4%',
                    taxRate: 0.04,
                }, {
                    taxText: '5%',
                    taxRate: 0.05,
                }, {
                    taxText: '6%',
                    taxRate: 0.06,
                }, {
                    taxText: '9%',
                    taxRate: 0.09,
                }, {
                    taxText: '10%',
                    taxRate: 0.10,
                }, {
                    taxText: '11%',
                    taxRate: 0.11,
                }, {
                    taxText: '13%',
                    taxRate: 0.13,
                }, {
                    taxText: '16%',
                    taxRate: 0.16,
                }, {
                    taxText: '17%',
                    taxRate: 0.17,
                }]
            } else {
                taxRateArr.unshift({
                    taxText: '减按1.5%计征',
                    taxRate: 0.015,
                })
                taxRateArr.unshift({
                    taxText: '0%',
                    taxRate: 0,
                })
            }
            return taxRateArr
        }
        // 对serial_no 排序 顺便转一下含税标志
        this.sortSerialNo = function (arr, serialNo, $scope) {
            const newArr = []
            const o = arr
            const _isTax = $scope.param.isTax
            for (const m in o) {
                o[m].isTax = _isTax
                if (o[m].hasOwnProperty(serialNo)) {
                    if (o[m].lineNature === '1') {
                        o[m].discountNo = o[m - 1].serialNo
                    }
                    o[m].serialNo = m
                }
                newArr.push(o[m])
            }
            return newArr
        }
        // 初始化发票种类
        this.initInvType = function (type) {
            if (type == '1') {
                return [{
                    enumCode: '0',
                    enumName: '专用发票',
                }, {
                    enumCode: '2',
                    enumName: '普通发票',
                }, {
                    enumCode: '12',
                    enumName: '机动车发票',
                }, {
                    enumCode: '14',
                    enumName: '通行费发票',
                }]
            }
            return [{
                enumCode: '51',
                enumName: '电子发票',
            }]
        }
        // 新增商品行初始化对象
        this.operatedAdd = function () {
            return {
                adValoremTotal: '',
                amount: '',
                amountAmt: '',
                balance: 0,
                discountAmt: 0,
                discountNo: '',
                discountRate: 0,
                discountTax: 0,
                extendInfo: '',
                id: '',
                invoiceId: '',
                isPrivilege: '',
                isTax: '',
                lineNature: '0',
                matCalss: '',
                matCode: '',
                matName: '',
                ownCoding: '',
                price: '',
                privilegeType: '',
                quantity: '',
                revenueCode: '',
                revenueName: '',
                revenueVersion: '',
                serialId: 0,
                serialNo: 0,
                sourceIdList: [],
                spec: '',
                taxAmount: '',
                taxPrice: '',
                taxRate: '',
                tenantId: 0,
                unit: '',
                zeroTax: '',
                passDetail: {
                    passDateBegin: '',
                    passDateEnd: '',
                    type: '',
                },
            }
        }
        // 发票种类变化
        this.invTypeChange = function (type) {
            // quota = quotasObj[$scope.param.invoiceType]
            // $scope.chosenType = $scope.param.invoiceType
            if (type == 2 || type == 51) {
                return [{
                    enumCode: '1',
                    enumName: '全票面库',
                }]
            }
            return [{
                enumCode: '1',
                enumName: '全票面库',
            }, {
                enumCode: '2',
                enumName: '电子底账库',
            }]

            // 税率数组
        }
        // 计算金额/税额合计 税价合计
        this.calTotalAmtTotalTaxamt = function (obj) {
            const waitDetailListLth = obj.detail ? obj.detail.length : 0
            const resObj = {}
            if (waitDetailListLth > 0) {
                let _totalAmt = 0
                let _totalTaxamt = 0
                for (let i = 0; i < waitDetailListLth; i++) {
                    _totalAmt = globalFn.Add(_totalAmt, obj.detail[i].amount)
                    _totalTaxamt = globalFn.Add(_totalTaxamt, obj.detail[i].taxAmount)
                }
                const _adValoremTotal = globalFn.Add(_totalAmt, _totalTaxamt)
                resObj.totalTaxamt = this._toFixed(_totalTaxamt, 2)
                resObj.totalAmt = this._toFixed(_totalAmt, 2)
                resObj.adValoremTotal = this._toFixed(_adValoremTotal, 2)
                resObj.adValoremTotalChinese = globalFn.digitUppercase(resObj.adValoremTotal)
            } else {
                const totalAmt = obj.totalAmt || 0
                const totalTaxamt = obj.totalTaxamt || 0
                const _adValoremTotal = globalFn.Add(totalAmt, totalTaxamt)
                resObj.totalTaxamt = this._toFixed(totalTaxamt, 2)
                resObj.totalAmt = this._toFixed(totalAmt, 2)
                resObj.adValoremTotal = this._toFixed(_adValoremTotal, 2)
                resObj.adValoremTotalChinese = globalFn.digitUppercase(resObj.adValoremTotal)
            }
            return resObj
        }
        // 主商品名和税率
        this.matNameAndRate = function ($scope) {
            // const waitDetailListLth = $scope.param.detail.length
            if (!$scope.param.detail || $scope.param.detail.length === 0) {
                return
            }
            const resObj = {}
            resObj.taxRate = $scope.param.detail[0].taxRate
            resObj.matName = $scope.param.detail[0].matName

            // 是否多税率
            let isMulRate = false
            const newRateArr = $scope.param.detail.map((item) => item.taxRate)
            for (let i = 0, l = newRateArr.length - 1; i < l; i++) {
                if (newRateArr[i] !== newRateArr[i + 1]) {
                    isMulRate = true
                    break
                }
            }
            if (isMulRate) {
                resObj.taxRate = ''
            }
            return resObj
        }
        // 校验是否系统维护值
        this.checkCodeTypeaheadSelect = function ($scope) {
            httpRequest.get_qryCustomerCodeAndOrg($scope.param.custCreditCode, $scope.pageState.userInfo.user.currentOrgId).then((res) => {
                const _resArr = res.data.value
                if (_resArr == null || _resArr.length == 0) {
                    return false
                }
                if (_resArr.customerName == $scope.param.custName && _resArr.creditCode == $scope.param.custCreditCode) {
                    return true
                }
            })
        }
        /**
         * 以下方法属于controller不应该写在service内、暂时写在这，以后抽离为组件
         */

        this.initBill = function ($scope, quotasObj, quota, fn) {
            $scope.param = {
                adValoremTotal: 0,
                adValoremTotalChinese: '零圆整',
                blueInvoiceCode: '',
                blueInvoiceNumber: '',
                checkCode: '',
                checker: '',
                creditCode: '',
                custAddress: $scope.pageState.userInfo.sale.registerAddress,
                custBank: $scope.pageState.userInfo.sale.saleBankAccount.bank,
                custBankAccount: $scope.pageState.userInfo.sale.saleBankAccount.bankAccount,
                custCreditCode: $scope.pageState.userInfo.sale.saleCreditCode,
                custName: $scope.pageState.userInfo.sale.saleName,
                custPhone: $scope.pageState.userInfo.sale.phone,
                orgCode: $scope.pageState.userInfo.org.orgCode,
                description: '',
                extendInfo: '',
                imageKey: '',
                inputBatchNo: '',
                detail: [],
                inputSerial: '',
                invoiceCode: '',
                invoiceDate: '',
                invoiceId: '',
                invoiceNumber: '',
                invoiceRemark: '',
                invoiceSource: '1',
                invoiceStatus: '',
                invoiceType: $scope.chosenType,
                invoiceBike: {
                    brandModel: '',
                    certificateNumber: '',
                    commInspectOddNumber: '',
                    dirTaxAuth: '',
                    dirTaxAuthCode: '',
                    engineNumber: '',
                    impCertificateNumber: '',
                    machineCode: '',
                    peopleNumber: '',
                    prodPlace: '',
                    proofNumber: '',
                    vehicleIdentNumber: '',
                    vehicleType: '',
                    weight: '',
                },
                isList: '0',
                openPeople: '',
                orgId: 0,
                payee: '',
                proofreadStatus: '',
                proofreadTime: '',
                redInfoNumber: '',
                saleAddress: '',
                salePhone: '',
                saleBank: '',
                saleBankAccount: '',
                saleCreditCode: '',
                saleId: '',
                saleName: '',
                secretCode: '',
                state: 1,
                taxRate: '0',
                totalAmt: 0,
                totalTaxamt: 0,
                verifyStatus: '',
                verifyTime: '',
            }
            // 税率数组
            $scope.taxRateArr = this.getTaxRateArr($scope.param.invoiceType)
            // 税价合计大写
            // $scope.adValoremTotalChinese = ''
            // 是否含税大写
            $scope.isTaxText = '不含税'
            $scope.param.isTax = '0'
            fn && fn()
            // 日期设置
            $('#invoiceDate').datetimepicker({
                autoclose: true,
                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                bootcssVer: 3,
                pickTime: false,
                pickerPosition: 'bottom-right',
            }).on('changeDate', (e) => {
                $scope.param.invoiceDate = e.target.value
            })
            // 日期设置
            $('#invoiceDate1').datetimepicker({
                autoclose: true,
                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                bootcssVer: 3,
                pickTime: false,
                pickerPosition: 'bottom-right',
                // startDate:"2017-01-01",
                // initialDate:now
            }).on('changeDate', (e) => {
                $scope.param.invoiceDate = e.target.value
            })
            // 开票点数据
            $scope.ukeyList = $scope.pageState.userInfo.sysUkeyList
            if ($scope.ukeyList != null && $scope.ukeyList.length > 0) {
                const _ukeyList0 = $scope.ukeyList[0]
                $scope.param.ukeyId = _ukeyList0.ukeyId
                $scope.param.ukeyCode = _ukeyList0.ukeyCode
                $scope.param.diskCode = _ukeyList0.diskCode
                $scope.param.diskId = _ukeyList0.diskId
                // 三个人
                $scope.param.payee = _ukeyList0.defaultPayee
                $scope.param.checker = _ukeyList0.defaultReviewer
                $scope.param.openPeople = _ukeyList0.defaultDrawer
                httpRequest.get_getTaxDisk($scope.param.ukeyId).then((res) => {
                    const _data = res.data
                    if (!_data.success) {
                        return
                    }
                    quotasObj['0'] = _data.value.specialQuota
                    quotasObj['2'] = _data.value.generalQuota
                    quotasObj['51'] = _data.value.electronicQuota
                    quota = quotasObj[$scope.param.invoiceType]
                    // 金税盘机器号
                    $scope.param.diskNo = _data.value.diskNo
                })
            }
        }
        // 购方模块自动补全POST /
        this.qryCustNameList = function ($scope, val) {
            if (this.lengthForString(val) > 100) {
                $scope.param.custName = ''
                $scope.typeaheadSelect = false
                logger.logError('购方名称长度不合法')
                return
            }
            return $http.post(`${host.etcloudOvat}settings/sysCustomer/qryByCodeOrName`, val).then((response) => {
                $scope.typeaheadSelect = false
                return response.data.value.map((item) => {
                    if (item.customerName == $scope.param.custName && item.creditCode == $scope.param.custCreditCode) {
                        $scope.typeaheadSelect = true
                    }
                    return $.extend({}, {
                        custCodeAndcustName: `${item.customerName}<span class="typeahead-taxname">${item.customerCode}</span>`,
                    }, item)
                })
            })
        }
        // 购方检测是否系统维护值
        this.isTypeaheadSelect = function (val, $scope) {
            if (this.lengthForString(val) === 0) {
                return
            }
            $http.post(`${host.etcloudOvat}settings/sysCustomer/qryByCodeOrName`, val).then((response) => {
                const _resArr = response.data.value
                if (_resArr == null || _resArr.length == 0) {
                    $scope.typeaheadSelect = false
                    return
                }
                _resArr.map((item) => {
                    const { taxplayerType } = item
                    if (item.customerName == $scope.param.custName && item.creditCode == $scope.param.custCreditCode && taxplayerType == $scope.param.creditType) {
                        $scope.typeaheadSelect = true
                    }
                })
            })
        }

        // 纳税人识别号检测
        this.taxNoChange = function ($scope) {
            if ($scope.param.custCreditCode !== '' && !globalFn.checkTax($scope.param.custCreditCode)) {
                logger.logError('购方纳税人识别号格式错误！')
                $scope.param.custCreditCode = ''
            }
        }
    }
}

billChangeService.$inject = ['logger', 'globalFn', 'sweetalert', 'httpRequest', '$http']
export default billChangeService



// WEBPACK FOOTER //
// ./src/common/services/billChangeService.js